import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function submitContact(payload) {
  const { data } = await api.post("/contact", payload);
  return data;
}

export async function submitBooking(payload) {
  const { data } = await api.post("/booking", payload);
  return data;
}

// --- Netlify Forms helper ---
// Submits a form to Netlify using the URL-encoded format Netlify expects.
// Works on any Netlify-deployed site that has the matching hidden static
// form declared in public/index.html.
function encode(data) {
  return Object.keys(data)
    .map(
      (k) =>
        encodeURIComponent(k) + "=" + encodeURIComponent(data[k] ?? "")
    )
    .join("&");
}

export async function submitNetlifyForm(formName, fields) {
  const payload = { "form-name": formName, ...fields };
  const res = await fetch("/", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: encode(payload),
  });
  if (!res.ok) {
    throw new Error(`Submission failed (${res.status})`);
  }
  return true;
}

